/**
 * Splits up an array into an array of arrays, for example
 * ([0, 1, 2, 3, 4, 5], 2) would return [[0, 1, 2], [3, 4, 5]]
 * ([0, 1, 2, 3, 4, 5], 3) would return [[0, 1], [2, 3], [4, 5]]
 *
 * @param {*} productList
 * @param {*} numberOfColumns
 */
export function splitIntoGroupOfArrays(productList, numberOfColumns) {
  let groupedArray = []
  let currentCount = -1

  groupedArray[currentCount] = []
  const maxColumnLength = Math.ceil(productList.length / numberOfColumns)
  productList.map((product, index) => {
    if (index % maxColumnLength === 0) {
      currentCount++
      groupedArray[currentCount] = []
    }
    groupedArray[currentCount].push(product)
  })

  return groupedArray
}

export function retrieveCusipAndClassLegacy(fund, fundClass) {
  let data = {
    cusip: '',
    fundClass: '',
  }

  for (const fd of fund.classes) {
    // If there's a match, use it...
    if (fd.fundClass === 'Class ' + fundClass) {
      data.cusip = fd.cusip
      data.fundClass = fundClass

      return data
    } else {
      // ...otherwise, set to first class listed by default
      if (!data.cusip) {
        data.cusip = fd.cusip
        data.fundClass = fundClass
      }
    }
  }

  return data
}

export function retrieveCusip(fund, fundClass) {
  let data = {}

  for (const fd of fund.classes) {
    if (fd.fundClass === fundClass) {
      data.cusip = fd.cusip
      data.fundClass = fd.fundClass
      return data
    } else if (fd.fundClass === null) {
      data.cusip = fd.cusip
      data.fundClass = ''
      return data
    } else {
      data.cusip = fund.classes[0].cusip
      data.fundClass = fund.classes[0].fundClass
    }
  }
  return data
}

export function sortBySubcategory(a, b) {
  const subCategorySortOrder = [
    'Large Value',
    'Large Blend',
    'Large Growth',
    'Mid-Cap Value',
    'Mid-Cap Blend',
    'Mid-Cap Growth',
    'Small Value',
    'Small Blend',
    'Small Growth',
    'Developed',
    'Emerging',
    'National',
    'State specific',
  ]

  let aScore = lookupSortWeightScore(subCategorySortOrder, a.subCtgValue)
  let bScore = lookupSortWeightScore(subCategorySortOrder, b.subCtgValue)

  if (aScore > bScore) {
    return 1
  } else if (aScore < bScore) {
    return -1
  } else {
    return 0
  }
}

export function splitGroupedFundsWithNoCategory(groupedFunds) {
  let fundsForCategory = {
    noCategory: null,
    noCategorySlice: null,
  }

  let midPoint = Math.floor(groupedFunds.length / 2)
  let arrayOne = groupedFunds.slice(0, midPoint)
  let arrayTwo = groupedFunds.slice(midPoint, groupedFunds.length)

  fundsForCategory['noCategory'] = arrayOne
  fundsForCategory['noCategorySlice'] = arrayTwo

  return fundsForCategory
}

function lookupSortWeightScore(sortingArray, value) {
  for (let i = 0; i < sortingArray.length; i++) {
    if (sortingArray[i] === value) {
      return i
    }
  }
  return 0
}

export function addTickerSymbol(array) {
  array.forEach((category) => {
    category.funds.forEach((indFund) => {
      indFund.symbol = indFund.classes[0].symbol
    })
  })
}

export function sortAlphaByProp(array, prop) {
  array.forEach((fund) => {
    fund.funds.sort(function (a, b) {
      let tickerA = a[prop]
      let tickerB = b[prop]

      if (tickerA < tickerB) {
        return -1
      } else if (tickerA > tickerB) {
        return 1
      } else {
        return 0
      }
    })
  })
}
